import { useMemo } from 'react'

import { MainContent, TopBar } from '@domain-group/suit-theme'

import useMainNavigation from '@hooks/useMainNavigation'

import LoggedInUser from '@components/LoggedInUser'
import MainNavigation from '@sections/Client/components/MainNavigation'

import CampaignRoutes from './routes'

import Navigation from './components/Navigation'

const Campaign = () => {
  const { callbacks: { toggleNavigation } } = useMainNavigation()

  return (
    <>
      <TopBar
        callbacks={{ toggleNavigation }}
        loggedInUserComponent={<LoggedInUser />}
        nestedNavigation
        searchComponent={<TopBar.Search callbacks={{ search: null }} />}
      />

      <MainNavigation minimized nestedNavigation={<Navigation />} />

      <MainContent nestedNavigation offset={{ top: TopBar.topBarHeight }}>
        <CampaignRoutes />
      </MainContent>
    </>
  )
}

export default Campaign
